import React, { useEffect, useState, useContext } from "react";
import { apiGetRequest } from "helpers/Requests";
import { useParams, useNavigate, useLocation } from "react-router";
import { LoginContext } from "helpers/LoginContext";
import {
  getNameProfile,
  selectedTabState,
  getFormSubTabForParticipantProfile,
  getUrlRole,
  getFormSubTabForSilProfile,
  SilHomeselectedTabState,
} from "Utils/utils";
import { PARENT_FORM_CATEGORY_SLUG, USER_ROLE } from "Constants/constant";
import SectionInputFields from "components/DynamicForms/SectionAndSubSectionFields/SectionsInputFields";
import HumanBodyModal from "components/Modals/HumanBody/HumanBodyModal";
import SideBar from "components/common/SideBar/SideBarNew";
import AlertModal from "components/Modals/alertModal";
import { roleAccess } from "helpers/RolesPermission";
import {
  BASE_URL,
  URL_SIL_ACCOMMODATION_SUBMITTED_FORM_DETAIL,
} from "store/services/URL";
import { BLK_PORTAL_PREMISSION_KEYS_CHILDREN } from "../../../store/constants";
import { useSelector } from "react-redux";
import { getUser } from "../../../store/selector/auth.selector";
import {
  FormPageBreadcrumb,
  FormPageHeader,
  FormMetaStrip,
  FormSectionList,
  FormSectionNav,
  FormPageLoader,
  FormPageShell,
  FormViewPage,
  buildSubmittedFormMetaItems,
} from "../shared/FormPageLayout";

const SupportPlanView = (props) => {
  const { slug: uuid, parentSlug } = useParams();
  const { routeRole = null } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { sideBarPadding } = useContext(LoginContext);
  const [viewFormData, setViewFormData] = useState(null);
  const [signatures, setSignatures] = useState(null);
  const [formData, setFormData] = useState(null);
  const [openBodyModal, setOpenBodyModal] = useState(false);
  const [selectedBody, setSelectedBody] = useState("");
  const [selectedLegal, setSelectedLegal] = useState(null);
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });

  const currentLoginUser = useSelector(getUser);
  const worker_uuid = currentLoginUser?.employee_uuid;
  const [workerUpdateCrmForm, setworkerUpdateCrmForm] = useState(false);
  const [workerCreateCrmForm, setworkerCreateCrmForm] = useState(false);

  const fetchFormTempletes = async () => {
    setRequest((prev) => ({ ...prev, isRequested: true }));
    try {
      let url = null;

      if (routeRole === "worker" && roleAccess([USER_ROLE.Sp_Standard_User])) {
        url = `worker/hrm/submitted-forms-view?form_id=${uuid}`;
      } else if (routeRole === "sil") {
        url = `${URL_SIL_ACCOMMODATION_SUBMITTED_FORM_DETAIL.replace(
          BASE_URL,
          ""
        )}?form_id=${uuid}`;
      } else {
        url = `${getUrlRole()}/participant/submitted-forms-view?form_id=${uuid}`;
      }

      const res = await apiGetRequest(url);
      if (res.status !== 200) {
        setRequest((prev) => ({ ...prev, isRequested: false, isFailed: true }));
      } else {
        setRequest((prev) => ({ ...prev, isRequested: false, isSuccess: true }));
        setFormData(res?.data?.submitted_form);
        if (res?.data?.submitted_form?.template?.length > 0) {
          setViewFormData(JSON.parse(res?.data?.submitted_form?.template));
          setSignatures(JSON.parse(res?.data?.submitted_form?.signatures));
        }
      }
    } catch (err) {
      setRequest((prev) => ({ ...prev, isRequested: false, isFailed: true }));
    }
  };

  useEffect(() => {
    if (roleAccess([USER_ROLE.Sp_Standard_User]) && routeRole === "crm") {
      if (
        roleAccess(
          [],
          "participant",
          BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.EDIT_ASSESSMENT_FORM
        ) &&
        parentSlug === PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG
      ) {
        setworkerUpdateCrmForm(true);
      } else if (
        roleAccess(
          [],
          "participant",
          BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.EDIT_EXIT_OR_TRANSITION
        ) &&
        parentSlug === PARENT_FORM_CATEGORY_SLUG.Exit_Transaction.SLUG
      ) {
        setworkerUpdateCrmForm(true);
      } else if (
        roleAccess(
          [],
          "participant",
          BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.EDIT_RISK_MANAGEMENT_FORM
        ) &&
        parentSlug === PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.SLUG
      ) {
        setworkerUpdateCrmForm(true);
      }

      if (
        roleAccess(
          [],
          "participant",
          BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.ADD
        ) &&
        parentSlug === PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG
      ) {
        setworkerCreateCrmForm(true);
      } else if (
        roleAccess(
          [],
          "participant",
          BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.EXIT_OR_TRANSITION
        ) &&
        parentSlug === PARENT_FORM_CATEGORY_SLUG.Exit_Transaction.SLUG
      ) {
        setworkerCreateCrmForm(true);
      } else if (
        roleAccess(
          [],
          "participant",
          BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.ACCESS_RISK_MANAGEMENT_FORM
        ) &&
        parentSlug === PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.SLUG
      ) {
        setworkerCreateCrmForm(true);
      }
    }
    fetchFormTempletes();
    return () => {
      if (
        routeRole !== "sil" &&
        getFormSubTabForParticipantProfile(parentSlug)
      ) {
        selectedTabState.save(
          JSON.stringify(getFormSubTabForParticipantProfile(parentSlug))
        );
      }
      if (routeRole === "sil" && getFormSubTabForSilProfile(parentSlug)) {
        SilHomeselectedTabState.save(getFormSubTabForSilProfile(parentSlug));
      }
    };
  }, [location?.pathname]);

  const handleImageError = (e, fname, lname) => {
    e.target.src = getNameProfile(fname, lname);
  };

  const getEditLinkProps = () => {
    if (!formData?.can_edit) return null;

    if (roleAccess([USER_ROLE.Sp_Standard_User])) {
      if (formData.is_complete) {
        const canEdit = workerUpdateCrmForm === true || routeRole !== "crm";
        return {
          to: canEdit
            ? `/${routeRole === "sil"
                ? "sil-accommodation"
                : routeRole === "crm"
                ? "participant-profile"
                : "submitted-form"
              }/${parentSlug}/${uuid}/update`
            : "#",
          label: "Edit Submission",
        };
      }
      const canComplete = workerCreateCrmForm === true || routeRole !== "crm";
      return {
        to: canComplete
          ? `/view-template/${
              routeRole === "sil"
                ? "/sil"
                : routeRole === "worker"
                ? "hrm/"
                : ""
            }${routeRole === "worker" ? worker_uuid : state?.particpantUuid}/${parentSlug}/${uuid}/${window.btoa(
              encodeURIComponent("false")
            )}`
          : "#",
        label: "Complete Submission",
      };
    }

    if (formData.is_complete) {
      return {
        to: `/${
          routeRole === "sil" ? "sil-accommodation" : "sp-profile"
        }/${parentSlug}/${uuid}/update`,
        state: { particpantUuid: state?.particpantUuid },
        label: "Edit Submission",
      };
    }

    return {
      to: `/view-template${routeRole === "sil" ? "/sil" : ""}/${
        state?.particpantUuid
      }/${parentSlug}/${uuid}/${window.btoa(encodeURIComponent("false"))}`,
      label: "Complete Submission",
    };
  };

  const editLink = getEditLinkProps();

  return (
    <>
      <div className="min-h-screen">
        <section className="print:hidden">
          <SideBar />
        </section>
        {request.isSuccess && viewFormData && formData ? (
          <FormViewPage
            sideBarPadding={sideBarPadding}
            header={
              <FormPageHeader
                title={formData.title}
                role={routeRole}
                sectionCount={viewFormData.length}
                status={formData.is_complete ? "complete" : "in-progress"}
                breadcrumb={
                  <FormPageBreadcrumb
                    formData={formData}
                    formTitle={formData.title}
                    parentSlug={parentSlug}
                    routeRole={routeRole}
                    participantUuid={
                      formData?.participant_uuid || state?.particpantUuid
                    }
                  />
                }
                editLink={editLink}
                onPrint={() => {
                  window.scrollTo(0, 0);
                  window.print();
                }}
                onBack={() => navigate(-1)}
              />
            }
          >
            <FormMetaStrip
              className="is-compact"
              items={buildSubmittedFormMetaItems({
                formData,
                routeRole,
                handleImageError,
              })}
            />
            {viewFormData.length > 1 && (
              <FormSectionNav sections={viewFormData} />
            )}
            <FormSectionList
              sections={viewFormData}
              formData={formData}
              renderFields={(section, index) => (
                <SectionInputFields
                  key={`${index}-${section?.section_title}`}
                  isViewable={true}
                  section={section}
                  index={index}
                  templateForm={formData}
                  participant={formData?.participant}
                  signatures={signatures ?? []}
                  setSelectedBody={setSelectedBody}
                  setOpenBodyModal={setOpenBodyModal}
                  setSelectedLegal={setSelectedLegal}
                />
              )}
            />
            {openBodyModal && (
              <HumanBodyModal
                view={true}
                selectedValue={selectedBody}
                isOpen={openBodyModal}
                closeModal={() => setOpenBodyModal(false)}
              />
            )}
            {selectedLegal && (
              <AlertModal
                show={selectedLegal !== null}
                handleClose={() => setSelectedLegal(null)}
              >
                {selectedLegal}
              </AlertModal>
            )}
          </FormViewPage>
        ) : (
          <FormPageShell sideBarPadding={sideBarPadding}>
            <FormPageLoader />
          </FormPageShell>
        )}
      </div>
    </>
  );
};

export default SupportPlanView;
